///<reference path="../require.d.ts"/>

interface Inquiry {
    customer_type: string;
    name: string;
    name_kana: string;
    representative: string;
    representative_kana: string;
    tel: string;
    email: string;
    questions: string[];
    accept: boolean;
    note: string;
}


class InquiryController {

    static $inject = ["$element", "$http"];

    contactType: string;
    inquiry: Inquiry;
    submitting: boolean = false;
    finished: boolean = false;

    constructor(
        private $element: angular.IAugmentedJQuery,
        private $http: angular.IHttpService
    ) {
        this.contactType = $element.data('contact');
        this.inquiry = {
            customer_type: '個人',
            name: '',
            name_kana: '',
            representative: '',
            representative_kana: '',
            tel: '',
            email: '',
            questions: [],
            accept: false,
            note: '',
        };
    }

    get nameLabel(): string {
        if (this.company) {
            return '御社名';
        } else {
            return 'お名前';
        }
    }

    get nameKanaLabel(): string {
        return this.nameLabel + 'カナ';
    }

    get company(): boolean {
        return this.inquiry.customer_type === '法人';
    }

    selectQuestion(selected: boolean, value: string): void {
        if (selected) {
            this.inquiry.questions.push(value);
        } else {
            this.inquiry.questions = this.inquiry.questions.filter((q) => q !== value);
        }
    }

    submit(form: angular.IFormController): void {
        if (/\/preview\/\d+$/.test(location.pathname)) {
            alert("プレビューではお問い合わせはできません。");
            return;
        }
        if (this.contactType === 'tel_or_mail') {
            const tel = form['tel'] as angular.INgModelController;
            const mail = form['email'] as angular.INgModelController;
            const valid = this.inquiry.tel !== '' || this.inquiry.email !== '';
            tel.$setValidity('required', valid);
            mail.$setValidity('required', valid);
        }
        if (!form.$valid) {
            for (let key in form) {
                if (!/^\$/.test(key)) {
                    form[key].$setDirty();
                }
            }
            alert("入力エラーがあります。\n表示が赤い箇所を確認してください。");
            return;
        }
        if (!this.inquiry.accept) {
           alert("個人情報保護に同意してください");
           return;
        }
        const params: any = this.inquiry;
        params.questions = this.inquiry.questions.join("\n");
        this.submitting = true;
        this.$http.post<void>(`${apiRoot}/general-inquiries`, params).success(() => {
            this.finished = true;
            setTimeout(() => $('html,body').animate({scrollTop: 0}, 'slow'), 0);
        });
    }
}



angular.module('hp').controller('InquiryController', InquiryController);



// WEBPACK FOOTER //
// ./controllers/InquiryController.ts